/* istanbul ignore file */
import { fetchTopBannerContent } from '@noths/polaris-client-banners';
import { DisplaySiteChromeUI, isTestVariant } from '@noths/polaris-client-experiments';
import { Environment, fetchNavigationContent } from '@noths/polaris-client-site-chrome-ui';
import {
  Environment as LegacyContentStackEnv,
  fetchNavigation,
  fetchTopBanner,
  initStackAndFetch,
} from '@noths/polaris-client-utils';
import { IncomingMessage } from 'http';
import * as runtimeProcess from 'process';

import { logger } from '../utils/serverLogger';

const { ENV_TYPE } = runtimeProcess.env;

const isProd = ENV_TYPE && ['production', 'staging', 'oldstaging'].includes(ENV_TYPE);

export const fetchData = async (req: IncomingMessage, experiments: string, urlPath?: string) => {
  const isSiteChromeExperiment = isTestVariant(DisplaySiteChromeUI, experiments);

  if (isSiteChromeExperiment) {
    const env = isProd ? Environment.Production : Environment.Qa;
    const config = { env, logger };

    return Promise.all([
      fetchNavigationContent(config).catch(() => null),
      fetchTopBannerContent(config, urlPath),
    ]);
  }

  const env = isProd ? LegacyContentStackEnv.Production : LegacyContentStackEnv.Qa;

  return initStackAndFetch(env, logger, [fetchNavigation, fetchTopBanner(urlPath)]);
};
